import { Drawer as BaseDrawer } from "@base-ui/react/drawer";
import {
  StyledPopup,
  StyledBackdrop,
  StyledViewport,
  DragHandle,
} from "./styles";
import { useDrawerShell, DrawerPopupContents } from "./DrawerShared";
import type { TypeDrawerProps } from "./DrawerTypes";

/**
 * Legacy styled-components shell. Routed to by `DrawerHybrid` whenever the
 * consumer passes styled-system props (or a `styled()` extension). Renders the
 * exact styled wrappers from `styles.ts` so behaviour is unchanged.
 */
const DrawerStyled = (props: TypeDrawerProps) => {
  const shell = useDrawerShell(props);
  const {
    effectiveDirection,
    hasSnapPoints,
    hasActionRail,
    rootProps,
    rest,
    width,
    offset,
    zIndex,
    id,
    open,
  } = shell;

  return (
    <BaseDrawer.Root {...rootProps}>
      <BaseDrawer.Portal>
        <StyledBackdrop data-testid="drawer-backdrop" />
        <StyledViewport $hasSnapPoints={hasSnapPoints}>
          <StyledPopup
            initialFocus={true}
            $width={width}
            $offset={offset}
            $direction={effectiveDirection}
            $zIndex={zIndex}
            $hasSnapPoints={hasSnapPoints}
            $hasActionRail={hasActionRail}
            data-qa-drawer={id}
            data-qa-drawer-isopen={open}
            {...rest}
          >
            {effectiveDirection === "bottom" && <DragHandle aria-hidden />}
            <DrawerPopupContents shell={shell} />
          </StyledPopup>
        </StyledViewport>
      </BaseDrawer.Portal>
    </BaseDrawer.Root>
  );
};

export default DrawerStyled;
